import { call, put, all, takeEvery } from "redux-saga/effects";

import { tourOrderActions } from '../slice/tourOrder'
import {
    createTourOrderApi,
    getTourOrderApi,
    updateTourOrderApi,
    getTourOrderByAdminApi,
    removeTourOrderApi,
    getTourOrderStatisticalApi
} from 'services/tourOrderServices'
import ShowToast from "utils/ShowToast";
import { updateTourOrderType } from "common/general";


function* handleCreateTourOrder(action) {
    try {
        const res = yield call(createTourOrderApi, action.payload.data)
        if (res.status === 200) {
            const response = res.data
            if (response.success === true) {
                yield put(tourOrderActions.createTourSuccess())
                action.payload.callBack()
                ShowToast('success', 'Đặt tour thành công, Kiểm tra lịch trình trong quản lý tour của bạn')
            } else {
                yield put(tourOrderActions.createTourFailed())
                ShowToast('error', 'Đặt tour thất bại, vui lòng thử lại sau!')
            }
        }
        else {
            yield put(tourOrderActions.createTourFailed())
            ShowToast('error', 'Đặt tour thất bại, vui lòng thử lại sau!')
        }
    } catch (error) {
        yield put(tourOrderActions.createTourFailed())
        ShowToast('error', 'Đặt tour thất bại, vui lòng thử lại sau!')
    }
}


function* handleUpdateTourOrder(action) {
    try {
        const res = yield call(updateTourOrderApi, action.payload.id, action.payload.data)
        if (res.status === 200) {
            const response = res.data
            if (response.success === true) {
                yield put(tourOrderActions.updateTourSuccess())
                yield put(tourOrderActions.getTour({ departureDay: action.payload.departureDay, status: action.payload.status }))
                if (action.payload.type === updateTourOrderType.CANCEL)
                    ShowToast('success', 'Hủy tour thành công!')
                if (action.payload.type === updateTourOrderType.REORDER)
                    ShowToast('success', 'Đặt lại tour thành công!')
                if (action.payload.type === updateTourOrderType.UPDATE)
                    ShowToast('success', 'Cập nhật tour thành công!')
            } else {
                yield put(tourOrderActions.updateTourFailed())
                ShowToast('error', 'Thất bại, vui lòng thử lại sau!')
            }
        }
        else {
            yield put(tourOrderActions.updateTourFailed())
            ShowToast('error', 'Thất bại, vui lòng thử lại sau!')
        }
    } catch (error) {
        yield put(tourOrderActions.updateTourFailed())
        ShowToast('error', 'Thất bại, vui lòng thử lại sau!')
    }
}


function* handleUpdateTourAdminOrder(action) {
    try {
        const res = yield call(updateTourOrderApi, action.payload.id, action.payload.data)
        if (res.status === 200) {
            const response = res.data
            if (response.success === true) {
                yield put(tourOrderActions.updateTourAdminSuccess())
                action.payload.callback()
                ShowToast('success', 'Cập nhật trạng thái thành công')
            } else {
                yield put(tourOrderActions.updateTourAdminFailed())
                ShowToast('error', 'Thất bại, vui lòng thử lại sau!')
            }
        }
        else {
            yield put(tourOrderActions.updateTourAdminFailed())
            ShowToast('error', 'Thất bại, vui lòng thử lại sau!')
        }
    } catch (error) {
        yield put(tourOrderActions.updateTourAdminFailed())
        ShowToast('error', 'Thất bại, vui lòng thử lại sau!')
    }
}

function* handleRemoveTourAdminOrder(action) {
    try {
        const res = yield call(removeTourOrderApi, action.payload.id)
        if (res.status === 200) {
            const response = res.data
            if (response.success === true) {
                yield put(tourOrderActions.removeTourSuccess())
                action.payload.callback()
                ShowToast('error', 'Xóa tour thành công')
            } else {
                yield put(tourOrderActions.removeTourFailed())
                ShowToast('error', 'Thất bại, vui lòng thử lại sau!')
            }
        }
        else {
            yield put(tourOrderActions.removeTourFailed())
            ShowToast('error', 'Thất bại, vui lòng thử lại sau!')
        }
    } catch (error) {
        yield put(tourOrderActions.removeTourFailed())
        ShowToast('error', 'Thất bại, vui lòng thử lại sau!')
    }
}



function* handleGetTourOrder(action) {
    try {
        const res = yield call(getTourOrderApi, action.payload.departureDay, action.payload.status)
        if (res.status === 200) {
            const response = res.data
            if (response.success === true) {
                yield put(tourOrderActions.getTourSuccess({ data: response.data }))
            } else {
                yield put(tourOrderActions.getTourFailed())
            }
        }
        else {
            yield put(tourOrderActions.getTourFailed())
        }
    } catch (error) {
        yield put(tourOrderActions.getTourFailed())
    }
}

function* handleGetTourOrderByAdmin(action) {
    try {
        const res = yield call(getTourOrderByAdminApi, action.payload.status, action.payload.query, action.payload.currentPage)
        if (res.status === 200) {
            const response = res.data
            if (response.success === true) {
                yield put(tourOrderActions.getTourAdminSuccess({ data: response.data, totalPage: response.totalPage, totalItem: response.totalItem }))
            } else {
                yield put(tourOrderActions.getTourAdminFailed())
            }
        }
        else {
            yield put(tourOrderActions.getTourAdminFailed())
        }
    } catch (error) {
        yield put(tourOrderActions.getTourAdminFailed())
    }
}


function* handleGetTourOrderStatistical(action) {
    try {
        const res = yield call(getTourOrderStatisticalApi, action.payload.tourType, action.payload.startDate, action.payload.endDate, action.payload.currentPage, action.payload.customer, action.payload.staff)
        if (res.status === 200) {
            const response = res.data
            if (response.success === true) {
                yield put(tourOrderActions.getStatisticalSuccess({ data: response.data, totalPage: response.totalPage, totalItem: response.totalItem }))
            } else {
                yield put(tourOrderActions.getStatisticalFailed())
            }
        }
        else {
            yield put(tourOrderActions.getStatisticalFailed())
        }
    } catch (error) {
        yield put(tourOrderActions.getStatisticalFailed())
    }
}



export default function* tourOrderSaga() {
    yield all(
        [
            takeEvery(tourOrderActions.createTour.type, handleCreateTourOrder),
            takeEvery(tourOrderActions.getTour.type, handleGetTourOrder),
            takeEvery(tourOrderActions.updateTour.type, handleUpdateTourOrder),
            takeEvery(tourOrderActions.getTourAdmin.type, handleGetTourOrderByAdmin),
            takeEvery(tourOrderActions.updateTourAdmin.type, handleUpdateTourAdminOrder),
            takeEvery(tourOrderActions.removeTour.type, handleRemoveTourAdminOrder),
            takeEvery(tourOrderActions.getStatistical.type, handleGetTourOrderStatistical),
        ]
    )
}
